import axios from '../axios-auth'

export const customerSaleReportByCategoryService = {
    getCustomerSaleReportByCategory,
    getAllCustomerSaleReportByCategoryPrint,
}

function getCustomerSaleReportByCategory(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/customer-sale-report-by-category", { params });
}

function getAllCustomerSaleReportByCategoryPrint(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate="] = searchParams.toDate;
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/customer-sale-report-by-category-print", { params });
}